import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el MegaPack después de comprar?',
    a: 'Después del pago recibís un email con tu acceso inmediato. Descargás los 6 tomos en PDF de alta calidad listos para imprimir o usar en pantalla. Tarda menos de 5 minutos.'
  }, {
    q: '¿Sirve para profes particulares o solo para academias?',
    a: 'Sirve especialmente para profes particulares con clases en casa o estudios propios. Los procesos están adaptados al profe independiente argentino. Si das en academia, también funciona pero algunos sistemas (recital, comunicación con familias) los adaptás al contexto institucional.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'Los tomos son PDFs profesionales pensados para usar como están. Las plantillas (cuaderno del alumno, reporte trimestral) las podés copiar y adaptar a tu marca personal.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'No. Los 6 bonos exclusivos vienen únicamente con el plan PREMIUM. El plan BASE incluye solo los 6 tomos del sistema central.'
  }, {
    q: '¿Sirve si soy profe nuevo con poca experiencia?',
    a: 'Sí, especialmente. El Tomo 1 te da la planificación anual lista. El Tomo 5 te enseña la técnica que te faltó en el conservatorio. El Bono 5 te enseña a poner precios. Es un atajo de 5 años de oficio.'
  }, {
    q: '¿Sirve para alumnos de todas las edades?',
    a: 'Sí. Hay material específico para niños (4-7 años, Tomo 2), principiantes mayores, adolescentes, adultos. Cada uno con su lógica pedagógica y su repertorio.'
  }, {
    q: '¿Qué pasa si tengo alumnos de distintos niveles en la misma clase?',
    a: 'El sistema de los 4 niveles (Iniciación, Principiante, Intermedio Temprano, Intermedio) está diseñado precisamente para eso. Tenés materiales adaptables a cada nivel y técnicas para manejar grupos mixtos.'
  }, {
    q: '¿Qué diferencia tiene Piano Listo con otros materiales?',
    a: 'La mayoría de los materiales de piano son métodos importados (alemanes, americanos, franceses) traducidos al español. Piano Listo es el primer sistema 100% pensado para el profe argentino, con sus realidades (honorarios, padres, formato de clase, recital, redes sociales).'
  }, {
    q: '¿Por qué elegir el Premium y no el plan Base?',
    a: 'El plan Base te da el sistema pedagógico. El Premium te da el sistema PROFESIONAL completo (tu marca, tus honorarios, tu Instagram, tu autoridad técnica con el diccionario). Es la diferencia entre "buen profesor" y "profesional respetado y bien pago".'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía sin preguntas. Si no te sirve, te devolvemos el 100% del dinero. La tasa de devolución real es menor al 1%.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-cream py-24" data-id="element-58">
      <div className="container mx-auto px-6" data-id="element-59">
        <FadeIn className="text-center mb-16" data-id="element-60">
          <h2 className="font-display font-bold text-4xl md:text-5xl text-navy-900" data-id="element-61">
            ❓ PREGUNTAS FRECUENTES
          </h2>
        </FadeIn>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-62">
          {faqs.map((faq, i) => <FadeIn key={i} delay={0.05 * i} direction="up" data-id="element-63">
              <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm transition-all hover:border-gold/50" data-id="element-64">
                <button onClick={() => toggleFAQ(i)} className="w-full text-left px-6 py-5 flex justify-between items-center focus:outline-none" data-id="element-65">
                  <span className="font-bold text-navy-900 pr-8" data-id="element-66">{faq.q}</span>
                  <span className={`text-gold text-xl transition-transform duration-300 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-67">
                    +
                  </span>
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === i ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-68">
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed border-t border-gray-100 pt-4" data-id="element-69">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}